// Bilingual content for La Hacienda Michoacán Supermarket
export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      departments: "Departments",
      menu: "Restaurant",
      gallery: "Gallery",
      reviews: "Reviews",
      visit: "Visit",
      faq: "FAQ",
      cta: "Get Directions",
    },
    hero: {
      eyebrow: "Authentic Mexican Market · Birmingham, AL",
      titleA: "A taste of",
      titleB: "Michoacán",
      titleC: "in the heart of Birmingham",
      subtitle:
        "A family-run supermarket and kitchen serving fresh produce, hand-cut meats, warm tortillas, pan dulce, and traditional Mexican meals — every day.",
      ctaMenu: "View Menu",
      ctaVisit: "Visit Us",
      rating: "4.6 stars · 36 Google reviews",
    },
    about: {
      eyebrow: "Our Story",
      title: "Rooted in Michoacán. Grown in Birmingham.",
      p1: "La Hacienda Michoacana began as a corner of home for the Mexican community of Birmingham — a place where you can find masa for your tamales, the right chile for your mole, and a smile when you walk in. Located in the Gilcrest Shopping Center on Green Springs Highway, our market brings the soul of Michoacán to every aisle.",
      p2: "Beyond a supermarket, we’re a kitchen. Our taquería inside serves the recipes that built our family — slow-cooked carnitas, handmade tortillas, and pozole that tastes like Sunday at abuela’s table.",
      stat1Label: "Years serving Birmingham",
      stat1Value: "10+",
      stat2Label: "Departments under one roof",
      stat2Value: "6",
      stat3Label: "Made-from-scratch dishes",
      stat3Value: "30+",
    },
    departments: {
      eyebrow: "Departments",
      title: "Everything for your kitchen, under one roof",
      items: [
        {
          key: "produce",
          name: "Fresh Produce",
          desc: "Tomatillos, nopales, chiles frescos, mangos, papayas — picked for flavor, not the shelf.",
        },
        {
          key: "carniceria",
          name: "Carnicería",
          desc: "Hand-cut beef, pork, and chicken. Marinated arrachera, chorizo, and milanesa ready to grill.",
        },
        {
          key: "panaderia",
          name: "Panadería",
          desc: "Conchas, orejas, cuernitos and pan dulce baked daily — plus a Coffee Bar to pair with your favorites.",
        },
        {
          key: "cremeria",
          name: "Cremería & Deli",
          desc: "Queso panela, Oaxaca, queso de puerco, jamón pierna, jamón pavo and crema suelta — cut to order at the deli case ($4.99 – $6.89 LB).",
        },
        {
          key: "accesorios",
          name: "Accesorios",
          desc: "Custom hair bows and accessories for little girls — handmade in-store and made-to-order in your colors. Social media link coming soon.",
        },
        {
          key: "remesas",
          name: "Envío de Remesas",
          desc: "Send money home to Mexico and Latin America. Fast, secure transfers — our bilingual team helps you fill everything out right the first time.",
        },
      ],
    },
    menu: {
      eyebrow: "The Restaurant Inside",
      title: "Comida casera, todos los días.",
      subtitle:
        "Real Mexican cooking from our family kitchen. Order at the counter, eat in or take home.",
      categories: [
        {
          name: "Tacos",
          items: [
            { name: "Tacos — Asada, Pastor, Pollo, Chorizo, Carnitas", desc: "Handmade tortilla, onion and cilantro.", price: "$3.00" },
            { name: "Tacos de Lengua, Birria de Res o Chivo", desc: "Slow-cooked specialty tacos on handmade tortilla.", price: "$3.89" },
          ],
        },
        {
          name: "Antojitos",
          items: [
            { name: "Empanadas (4 pc)", desc: "Filled with cheese, chicken or chorizo with potatoes — lettuce, queso, crema.", price: "$13.99" },
            { name: "Picaditas", desc: "Red or green salsa, queso and onion. Per piece.", price: "$2.49 ea" },
            { name: "Sopes", desc: "Chicken, asada or chorizo. Lettuce, queso, crema. Per piece.", price: "$3.49 ea" },
            { name: "Pupusa", desc: "Salvadoran-style stuffed masa, per piece.", price: "$3.49 ea" },
            { name: "Pambazo", desc: "Papas con chorizo, frijoles, lettuce, queso and crema.", price: "$10.99" },
          ],
        },
        {
          name: "Especialidades",
          items: [
            { name: "Quesabirrias (3 pc)", desc: "Three quesabirrias served with consomé.", price: "$13.99" },
            { name: "Carne Asada", desc: "Grilled steak with rice, beans and salad.", price: "$16.99" },
            { name: "Enchiladas Mexicanas (4 pc)", desc: "Filled with cheese, chicken or cecina; veggies, lettuce, queso, crema.", price: "$13.99" },
            { name: "Mojarra Frita", desc: "Whole fried tilapia with rice and salad.", price: "$17.99" },
            { name: "Tacos Ahogados (3 pc)", desc: "Crispy potato tacos with beans, carnitas, cabbage, tomato salsa and spicy salsa.", price: "$12.99" },
          ],
        },
        {
          name: "Burritos & Caldos",
          items: [
            { name: "Burrito Vegetariano", desc: "Rice, beans, lettuce, queso, crema and guacamole.", price: "$12.99" },
            { name: "Burrito de Asada, Pollo, Fajita Mix or Chorizo", desc: "With onion and bell pepper, rice, beans, queso, crema.", price: "$13.99" },
            { name: "Menudo y Pozole", desc: "Traditional bowls with garnishes.", price: "$13.99" },
            { name: "Caldo de Res (weekends)", desc: "Beef and vegetable broth — weekends only.", price: "$13.99" },
          ],
        },
        {
          name: "Sides & Aguas",
          items: [
            { name: "Arroz o Frijol — Chico", desc: "Small side of rice or beans.", price: "$3.99" },
            { name: "Arroz o Frijol — Mediano", desc: "Medium side.", price: "$5.99" },
            { name: "Arroz o Frijol — Grande", desc: "Large family-size side.", price: "$9.99" },
            { name: "Aguas Frescas", desc: "Horchata, jamaica, tamarindo, sandía.", price: "$3.99" },
            { name: "Atole", desc: "Warm masa-based drink.", price: "$3.69" },
          ],
        },
      ],
      footnote: "From our in-store menu board. Call (205) 983-7363 for daily specials and weekend menudo & caldo de res.",
      sidesCaption: "Postres & aguas para llevar",
    },
    weekend: {
      eyebrow: "Saturday & Sunday Specials",
      title: "Weekend at La Hacienda.",
      subtitle: "Recipes worth the drive — only Saturdays and Sundays.",
      cta: "Order ahead — (205) 983-7363",
      day: "Sat – Sun",
      items: [
        {
          name: "Menudo",
          desc: "Slow-simmered tripe in red chile broth, served with onion, oregano, lime and tortillas.",
          price: "$13.99",
        },
        {
          name: "Pozole Rojo",
          desc: "Pork and hominy in red chile, garnished with cabbage, radish, oregano and lime.",
          price: "$13.99",
        },
        {
          name: "Caldo de Res",
          desc: "Beef and garden vegetables in a clear broth, with rice and warm tortillas.",
          price: "$13.99",
        },
      ],
    },
    gallery: {
      eyebrow: "Inside the Hacienda",
      title: "A walk through the market.",
    },
    reviews: {
      eyebrow: "From Our Customers",
      title: "What Birmingham is saying.",
      googleRating: "4.6 on Google",
      items: [
        {
          name: "Wisdom Hancock",
          quote:
            "They were very nice and clean! I got everything I needed to make pozole and tamales for the holidays!",
        },
        {
          name: "Aaron Dye",
          quote:
            "The lady at the deli counter knew we’d have a language gap, so she called a young lady off her break to help. She took care of our order and was very pleasant. You have a great team member there.",
        },
        {
          name: "Local Guide",
          quote:
            "I highly recommend this place to get and make a good nice meal.",
        },
      ],
    },
    faq: {
      eyebrow: "Frequently Asked",
      title: "Good to know before you visit.",
      subtitle:
        "Answers based on what our Birmingham neighbors ask us most often, pulled from our Google profile and our day-to-day at the store.",
      callUs: "Call us directly:",
      items: [
        {
          q: "What are your hours?",
          a: "We’re open seven days a week, every day from 7:00 AM to 9:00 PM. Holiday hours may vary — call ahead during major holidays.",
        },
        {
          q: "Where are you located?",
          a: "We’re inside the Gilcrest Shopping Center at 118 Green Springs Hwy, Birmingham, AL 35209. There’s plenty of free parking right in front of the store.",
        },
        {
          q: "Do you offer curbside pickup?",
          a: "Yes — curbside pickup is available. Call us at (205) 983-7363 to place your order, and pull into the front spaces marked for pickup when you arrive.",
        },
        {
          q: "Is there a restaurant inside the supermarket?",
          a: "Yes. Our in-store taquería serves handmade-tortilla tacos (asada, pastor, pollo, chorizo, carnitas, lengua, birria de res o chivo), quesabirrias with consomé, enchiladas mexicanas, sopes, picaditas, pupusas, pambazos, burritos, mojarra frita, carne asada plates, menudo, pozole, weekend caldo de res, and aguas frescas. Order at the counter — eat in or take out.",
        },
        {
          q: "Do you carry ingredients for pozole and tamales?",
          a: "Absolutely. Maíz pozolero, masa preparada, hojas de maíz, chiles secos (guajillo, ancho, pasilla), specialty meats, and everything you need for tamales and pozole. Just ask a team member if you can’t find something.",
        },
        {
          q: "Is your produce really fresh?",
          a: "Yes. We source tomatillos, nopales, chiles frescos, mangos, papayas and more multiple times per week so you’re picking from the freshest selection in Birmingham.",
        },
        {
          q: "¿Hablan español?",
          a: "Sí — la mayoría de nuestro equipo habla español y atiende con gusto en cualquiera de los dos idiomas. Yes, most of our team is bilingual and happy to help in English or Spanish.",
        },
        {
          q: "Do you take phone orders for the deli or restaurant?",
          a: "Yes — call (205) 983-7363 and we’ll take your order for the deli counter or the taquería. Larger catering orders please give us 24 hours notice.",
        },
        {
          q: "Do you accept credit and debit cards?",
          a: "Yes, we accept all major credit and debit cards as well as cash. EBT/SNAP is accepted on eligible grocery items.",
        },
        {
          q: "Can I order catering for parties or events?",
          a: "Yes! We cater carnitas, tamales, pozole, taquizas, and trays for parties and office events. Call us to plan the menu.",
        },
      ],
    },
    visit: {
      eyebrow: "Visit Us",
      title: "Come on in.",
      address: "118 Green Springs Hwy, Birmingham, AL 35209",
      located: "Located in: Gilcrest Shopping Center",
      phoneLabel: "Phone",
      phone: "(205) 983-7363",
      hoursLabel: "Hours",
      hours: [
        { day: "Every day", time: "7:00 AM – 9:00 PM" },
      ],
      services: ["In-store shopping", "Curbside pickup"],
      formTitle: "Send us a message",
      formSubtitle: "Questions about catering, special orders, or the deli? We’ll get back to you.",
      name: "Name",
      email: "Email",
      phoneOpt: "Phone (optional)",
      message: "Message",
      submit: "Send message",
      sending: "Sending…",
      successTitle: "Mensaje recibido — thank you!",
      successDesc: "We’ll be in touch shortly.",
      errorTitle: "Something went wrong",
      errorDesc: "Please try again or call us directly.",
      directions: "Get Directions",
    },
    footer: {
      tagline: "Authentic Michoacán flavors, served daily in Birmingham, Alabama.",
      navTitle: "Explore",
      visitTitle: "Visit",
      socialTitle: "Follow",
      copyright: "© {year} La Hacienda Michoacana Supermarket. All rights reserved.",
    },
    catering: {
      eyebrow: "Catering",
      title: "Let us feed your party.",
      subtitle:
        "Trays of carnitas, tamales, pozole, taquizas, and bandejas surtidas — tell us about your event and we’ll send a quote.",
      formTitle: "Request a quote",
      name: "Name",
      email: "Email",
      phone: "Phone",
      date: "Event date",
      guests: "Guests",
      eventType: "Event type",
      details: "Tell us about the menu, dietary needs, drop-off vs. pickup, etc.",
      submit: "Request quote",
      sending: "Sending…",
      successTitle: "Quote request received — thank you!",
      successDesc: "We’ll be in touch within 24 hours.",
      errorTitle: "Couldn’t send",
      errorDesc: "Please try again or call (205) 983-7363.",
      types: ["Family Gathering", "Office / Work", "Holiday Party", "Other"],
      note: "Larger orders — please give us 24+ hours notice.",
    },
    announcement: { dismiss: "Dismiss" },
    scrollTop: "Back to top",
    common: { open: "Open · Closes 9 PM" },
  },
  es: {
    nav: {
      home: "Inicio",
      about: "Nosotros",
      departments: "Departamentos",
      menu: "Restaurante",
      gallery: "Galería",
      reviews: "Reseñas",
      visit: "Visítanos",
      faq: "Preguntas",
      cta: "Cómo llegar",
    },
    hero: {
      eyebrow: "Mercado Mexicano Auténtico · Birmingham, AL",
      titleA: "Un sabor de",
      titleB: "Michoacán",
      titleC: "en el corazón de Birmingham",
      subtitle:
        "Un supermercado y cocina familiar con verdura fresca, carnes de mostrador, tortillas calientitas, pan dulce y comida tradicional mexicana — todos los días.",
      ctaMenu: "Ver Menú",
      ctaVisit: "Visítanos",
      rating: "4.6 estrellas · 36 reseñas en Google",
    },
    about: {
      eyebrow: "Nuestra Historia",
      title: "Con raíces en Michoacán. Crecidos en Birmingham.",
      p1: "La Hacienda Michoacana nació como un rinconcito de casa para la comunidad mexicana de Birmingham — un lugar donde encuentras la masa para tus tamales, el chile justo para tu mole, y siempre una sonrisa al entrar. Ubicados en el Gilcrest Shopping Center sobre Green Springs Highway, traemos el alma de Michoacán a cada pasillo.",
      p2: "Más que un supermercado, somos una cocina. Nuestra taquería sirve las recetas que formaron a nuestra familia — carnitas a fuego lento, tortillas hechas a mano y pozole que sabe a domingo en la mesa de la abuela.",
      stat1Label: "Años sirviendo a Birmingham",
      stat1Value: "10+",
      stat2Label: "Departamentos bajo un techo",
      stat2Value: "6",
      stat3Label: "Platillos hechos en casa",
      stat3Value: "30+",
    },
    departments: {
      eyebrow: "Departamentos",
      title: "Todo para tu cocina, bajo un mismo techo",
      items: [
        {
          key: "produce",
          name: "Frutas y Verduras",
          desc: "Tomatillos, nopales, chiles frescos, mangos, papayas — escogidos por sabor, no por estante.",
        },
        {
          key: "carniceria",
          name: "Carnicería",
          desc: "Cortes de res, cerdo y pollo al momento. Arrachera marinada, chorizo y milanesa listas para asar.",
        },
        {
          key: "panaderia",
          name: "Panadería",
          desc: "Conchas, orejas, cuernitos y pan dulce horneados a diario — y un Coffee Bar para acompañar tus favoritos.",
        },
        {
          key: "cremeria",
          name: "Cremería y Deli",
          desc: "Queso panela, Oaxaca, queso de puerco, jamón pierna, jamón pavo y crema suelta — cortados al momento ($4.99 – $6.89 LB).",
        },
        {
          key: "accesorios",
          name: "Accesorios",
          desc: "Moños y accesorios para niñas — hechos a mano en la tienda y bajo pedido en los colores que prefieras. Redes sociales muy pronto.",
        },
        {
          key: "remesas",
          name: "Envío de Remesas",
          desc: "Envía dinero a tu familia en México y Latinoamérica. Transferencias rápidas y seguras — y nuestro equipo bilingüe te ayuda a llenar todo a la primera.",
        },
      ],
    },
    menu: {
      eyebrow: "El Restaurante Adentro",
      title: "Comida casera, todos los días.",
      subtitle:
        "Cocina mexicana de verdad, hecha en familia. Pide en el mostrador, come aquí o llévatelo a casa.",
      categories: [
        {
          name: "Tacos",
          items: [
            { name: "Tacos — Asada, Pastor, Pollo, Chorizo, Carnitas", desc: "Tortilla hecha a mano, cebolla y cilantro.", price: "$3.00" },
            { name: "Tacos de Lengua, Birria de Res o Chivo", desc: "Especialidades a fuego lento en tortilla hecha a mano.", price: "$3.89" },
          ],
        },
        {
          name: "Antojitos",
          items: [
            { name: "Empanadas (4 pz)", desc: "Rellenas de queso, pollo o chorizo con papas — lechuga, queso, crema.", price: "$13.99" },
            { name: "Picaditas", desc: "Con salsa roja o verde, queso y cebolla. Por pieza.", price: "$2.49 pz" },
            { name: "Sopes", desc: "Pollo, asada o chorizo. Lechuga, queso y crema. Por pieza.", price: "$3.49 pz" },
            { name: "Pupusa", desc: "Estilo salvadoreño, por pieza.", price: "$3.49 pz" },
            { name: "Pambazo", desc: "Papas con chorizo, frijoles, lechuga, queso y crema.", price: "$10.99" },
          ],
        },
        {
          name: "Especialidades",
          items: [
            { name: "Quesabirrias (3 pz)", desc: "Tres quesabirrias servidas con consomé.", price: "$13.99" },
            { name: "Carne Asada", desc: "Bistec asado con arroz, frijol y ensalada.", price: "$16.99" },
            { name: "Enchiladas Mexicanas (4 pz)", desc: "Rellenas de queso, pollo o cecina; verdura, lechuga, queso, crema.", price: "$13.99" },
            { name: "Mojarra Frita", desc: "Mojarra entera frita con arroz y ensalada.", price: "$17.99" },
            { name: "Tacos Ahogados (3 pz)", desc: "Tacos dorados de papa con frijoles, carnitas, repollo, salsa de tomate y salsa picosa.", price: "$12.99" },
          ],
        },
        {
          name: "Burritos y Caldos",
          items: [
            { name: "Burrito Vegetariano", desc: "Arroz, frijol, lechuga, queso, crema y guacamole.", price: "$12.99" },
            { name: "Burrito de Asada, Pollo, Fajita Mix o Chorizo", desc: "Con cebolla y pimiento, arroz, frijol, queso y crema.", price: "$13.99" },
            { name: "Menudo y Pozole", desc: "Tradicionales con sus guarniciones.", price: "$13.99" },
            { name: "Caldo de Res (fin de semana)", desc: "Caldo de res con verduras — solo fines de semana.", price: "$13.99" },
          ],
        },
        {
          name: "Acompañamientos y Aguas",
          items: [
            { name: "Arroz o Frijol — Chico", desc: "Porción chica de arroz o frijol.", price: "$3.99" },
            { name: "Arroz o Frijol — Mediano", desc: "Porción mediana.", price: "$5.99" },
            { name: "Arroz o Frijol — Grande", desc: "Porción familiar.", price: "$9.99" },
            { name: "Aguas Frescas", desc: "Horchata, jamaica, tamarindo, sandía.", price: "$3.99" },
            { name: "Atole", desc: "Bebida caliente de masa.", price: "$3.69" },
          ],
        },
      ],
      footnote: "Tomado de nuestro menú en tienda. Llama al (205) 983-7363 para los especiales del día y el menudo y caldo de res de fin de semana.",
      sidesCaption: "Postres y aguas frescas para llevar",
    },
    weekend: {
      eyebrow: "Especiales de Sábado y Domingo",
      title: "Fin de semana en La Hacienda.",
      subtitle: "Recetas que valen el viaje — solo sábados y domingos.",
      cta: "Llama para apartar — (205) 983-7363",
      day: "Sáb – Dom",
      items: [
        {
          name: "Menudo",
          desc: "Pancita a fuego lento en caldo rojo, con cebolla, orégano, limón y tortillas.",
          price: "$13.99",
        },
        {
          name: "Pozole Rojo",
          desc: "Cerdo y maíz pozolero en chile rojo, con repollo, rábano, orégano y limón.",
          price: "$13.99",
        },
        {
          name: "Caldo de Res",
          desc: "Res y verduras del campo en caldo claro, con arroz y tortillas calientitas.",
          price: "$13.99",
        },
      ],
    },
    gallery: {
      eyebrow: "Por Dentro de la Hacienda",
      title: "Un paseo por el mercado.",
    },
    reviews: {
      eyebrow: "Lo que dicen nuestros clientes",
      title: "Birmingham nos lo cuenta.",
      googleRating: "4.6 en Google",
      items: [
        {
          name: "Wisdom Hancock",
          quote:
            "¡Muy amables y limpio! Encontré todo lo que necesitaba para hacer pozole y tamales para las fiestas.",
        },
        {
          name: "Aaron Dye",
          quote:
            "La señora del mostrador supo que tendríamos un problema de idioma, así que llamó a una compañera para ayudarnos. Tomó nuestra orden con mucha amabilidad — un gran equipo.",
        },
        {
          name: "Local Guide",
          quote: "Recomiendo mucho este lugar para conseguir y preparar una buena comida.",
        },
      ],
    },
    faq: {
      eyebrow: "Preguntas Frecuentes",
      title: "Lo que conviene saber antes de venir.",
      subtitle:
        "Respuestas a lo que más nos preguntan los vecinos de Birmingham, basadas en nuestro perfil de Google y el día a día de la tienda.",
      callUs: "Llámanos directamente:",
      items: [
        {
          q: "¿Cuál es su horario?",
          a: "Abrimos los siete días de la semana, todos los días de 7:00 AM a 9:00 PM. En días festivos el horario puede variar — llámanos para confirmar.",
        },
        {
          q: "¿Dónde están ubicados?",
          a: "Estamos dentro del Gilcrest Shopping Center, en 118 Green Springs Hwy, Birmingham, AL 35209. Hay bastante estacionamiento gratis al frente de la tienda.",
        },
        {
          q: "¿Tienen curbside pickup?",
          a: "Sí — ofrecemos curbside pickup. Llama al (205) 983-7363 para hacer tu pedido y estaciónate en los lugares marcados al frente cuando llegues.",
        },
        {
          q: "¿Hay un restaurante dentro del supermercado?",
          a: "Sí. Nuestra taquería interior sirve tacos en tortilla hecha a mano (asada, pastor, pollo, chorizo, carnitas, lengua, birria de res o chivo), quesabirrias con consomé, enchiladas mexicanas, sopes, picaditas, pupusas, pambazos, burritos, mojarra frita, platos de carne asada, menudo, pozole, caldo de res los fines de semana y aguas frescas. Pide en el mostrador — para comer aquí o para llevar.",
        },
        {
          q: "¿Tienen ingredientes para pozole y tamales?",
          a: "¡Claro! Maíz pozolero, masa preparada, hojas de maíz, chiles secos (guajillo, ancho, pasilla), carnes especiales y todo lo que necesitas para pozole y tamales. Si no encuentras algo, pregúntale a cualquiera del equipo.",
        },
        {
          q: "¿Las verduras de verdad están frescas?",
          a: "Sí. Recibimos tomatillos, nopales, chiles frescos, mangos, papayas y más varias veces por semana, así escoges de lo más fresco en Birmingham.",
        },
        {
          q: "¿Hablan español?",
          a: "Sí — la mayoría de nuestro equipo habla español y atiende con gusto en cualquiera de los dos idiomas. Yes, most of our team is bilingual and happy to help in English or Spanish.",
        },
        {
          q: "¿Toman pedidos por teléfono para la carnicería o el restaurante?",
          a: "Sí — marca (205) 983-7363 y tomamos tu pedido para la carnicería o la taquería. Para pedidos grandes de banquetes, agradecemos 24 horas de aviso.",
        },
        {
          q: "¿Aceptan tarjetas de crédito y débito?",
          a: "Sí, aceptamos las principales tarjetas de crédito y débito, además de efectivo. También aceptamos EBT/SNAP en los productos elegibles.",
        },
        {
          q: "¿Hacen banquetes para fiestas y eventos?",
          a: "¡Sí! Hacemos carnitas, tamales, pozole, taquizas y bandejas para fiestas y eventos de oficina. Llámanos para armar el menú.",
        },
      ],
    },
    visit: {
      eyebrow: "Visítanos",
      title: "Pásale, te esperamos.",
      address: "118 Green Springs Hwy, Birmingham, AL 35209",
      located: "Ubicados en: Gilcrest Shopping Center",
      phoneLabel: "Teléfono",
      phone: "(205) 983-7363",
      hoursLabel: "Horario",
      hours: [
        { day: "Todos los días", time: "7:00 AM – 9:00 PM" },
      ],
      services: ["Compra en tienda", "Curbside pickup"],
      formTitle: "Mándanos un mensaje",
      formSubtitle: "¿Preguntas sobre banquetes, pedidos especiales o la carnicería? Te respondemos pronto.",
      name: "Nombre",
      email: "Correo",
      phoneOpt: "Teléfono (opcional)",
      message: "Mensaje",
      submit: "Enviar mensaje",
      sending: "Enviando…",
      successTitle: "¡Mensaje recibido — gracias!",
      successDesc: "Te contactaremos pronto.",
      errorTitle: "Algo salió mal",
      errorDesc: "Inténtalo de nuevo o llámanos directamente.",
      directions: "Cómo llegar",
    },
    footer: {
      tagline: "Auténticos sabores de Michoacán, servidos a diario en Birmingham, Alabama.",
      navTitle: "Explora",
      visitTitle: "Visita",
      socialTitle: "Síguenos",
      copyright: "© {year} La Hacienda Michoacana Supermarket. Todos los derechos reservados.",
    },
    catering: {
      eyebrow: "Banquetes",
      title: "Nosotros le ponemos la comida a tu fiesta.",
      subtitle:
        "Bandejas de carnitas, tamales, pozole, taquizas y bandejas surtidas — cuéntanos del evento y te pasamos cotización.",
      formTitle: "Pide tu cotización",
      name: "Nombre",
      email: "Correo",
      phone: "Teléfono",
      date: "Fecha del evento",
      guests: "Invitados",
      eventType: "Tipo de evento",
      details: "Cuéntanos del menú, restricciones, si quieres entrega o lo recoges, etc.",
      submit: "Pedir cotización",
      sending: "Enviando…",
      successTitle: "¡Solicitud recibida — gracias!",
      successDesc: "Te contactamos en menos de 24 horas.",
      errorTitle: "No se pudo enviar",
      errorDesc: "Inténtalo de nuevo o llama al (205) 983-7363.",
      types: ["Reunión familiar", "Oficina / Trabajo", "Fiesta de temporada", "Otro"],
      note: "Para pedidos grandes — avísanos con 24+ horas de anticipación.",
    },
    announcement: { dismiss: "Cerrar" },
    scrollTop: "Volver arriba",
    common: { open: "Abierto · Cierra a las 9 PM" },
  },
};
